<!--TODO Explain Code with comment modules-->

<template>
  <div id="nav" class="bg-background-primary shadow h-full">
    <!--    big screen logo-->
    <div class="logo  w-full hidden sm:flex p-4 pl-8 ">
      <div class="w-24 relative cursor-pointer" @click="$router.push('/')">
        <img v-if="theme_color === 'theme-light'" alt="logo" src="../../assets/images/logo_yellow.svg">
        <img v-else alt="logo" src="../../assets/images/logo_yellow_white.svg">
      </div>
    </div>
    <!--    big screen  logo-->

    <!--    small screen  logo-->
    <div :class="{'hidden': !showMenu}" class="absolute flex sm:hidden cursor-pointer pt-4 right-0">
      <div class="shadow-lg p-1 px-1 pl-1 rounded-l-lg flex justify-center items-center" @click="toggleMenu(false)">
        <feather-icon icon="ChevronLeftIcon"
                      svgClasses="h-5 w-5"/>
        <!--        <feather-icon icon="ChevronLeftIcon"-->
        <!--                      svgClasses="h-5 w-5"/>-->
      </div>

    </div>
    <!--    full open menu with routes name-->
    <div class="logo  w-full flex sm:hidden p-1 my-2 ">
      <div class="relative cursor-pointer" @click="$router.push('/')">
        <img :class="{'hidden': showMenu}" alt="logo" src="../../assets/images/small_logo_yellow.svg">
        <div :class="{'hidden': !showMenu}" class="pl-6">
          <img v-if="theme_color === 'theme-light'" :class="{'w-16': showMenu}" alt="logo"
               src="../../assets/images/logo_medium_yellow.svg">
          <img v-else :class="{'w-16': showMenu}" alt="logo" class="w-1"
               src="../../assets/images/logo_medium_yellow_white.svg">
        </div>
      </div>
    </div>
    <!--    full open menu with routes name-->
    <!--    small screen  logo-->
    <!--    big screen Navigation-->
    <div v-for="route in routePoint" v-bind:key="route.name" class="hidden sm:flex flex-col">
      <router-link :to='route.path' class="links flex">
        <feather-icon :icon="route.icon" class=" pr-3" svgClasses="h-5 w-5"/>
        {{ route.name }}
      </router-link>
    </div>
    <!--    big screen Navigation-->
    <!--    small screen Navigation-->
    <div v-for="route in routePoint" v-bind:key="route.path" :class="{'items-center': !showMenu,'mx-3': showMenu}"
         class="flex sm:hidden flex-col">
      <router-link :to='route.path' class="links-small flex">
        <feather-icon :icon="route.icon" class="" svgClasses="h-5 w-5"/>
        <p :class="{'hidden': !showMenu,'pl-3': showMenu}">{{ route.name }}</p>
      </router-link>
    </div>
    <!--    small screen Navigation-->
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import routePoint from './NavItems'

export default {
  name: 'Navigation',
  computed: {
    ...mapState({
      theme_color: state => state.theme.themeColor
    }),
    ...mapGetters({
      showMenu: 'rwd/show_menu'
    })
  },
  methods: {
    ...mapActions({
      toggleMenu: 'rwd/toggleMenu'
    })
  },
  data: () => ({
    routePoint
  })
}
</script>
<style scoped>
/*router-link active class*/
#nav a.router-link-exact-active {
  /*@apply border-theme-primary border-l-2 text-theme-primary bg-background-secondary;*/
  @apply text-white shadow-lg rounded-lg;
  background: linear-gradient(75deg, #F4BE19 0%, #f4cf6d 100%);
}

/*router-links*/
.links {
  @apply p-3 text-left pl-4 text-txt-primary text-xl mb-1 mx-3;
}

.links-small {
  @apply p-2 text-left text-txt-primary text-xl m-1;
}
</style>
